import { Travel as ProTravel, TravelApiInterface as ProTravelApiInterface } from "@syadem/kairos-pro-js";
import { Travel as TeamTravel, TravelApiInterface as TeamTravelApiInterface } from "@syadem/kairos-team-js";
import { ActionResult } from "../../actionResult";
import { TravelSnapshot } from "../../domain/travel";
import { toApiTravel } from "../../network/apis/travelMapper";
import { AppStore } from "../../store";
import { Service } from "../service";

interface Payload {
  organizationId: string | null;
  teamId: string | null;
  healthRecordId: string;
  travelId: string;
  travel: TravelSnapshot;
}

export class UpdateTravelService implements Service<Payload, ProTravel | TeamTravel> {
  constructor(
    private readonly proTravelApi: ProTravelApiInterface,
    private readonly teamTravelApi: TeamTravelApiInterface,
    private readonly store: AppStore,
  ) {}

  async call({
    organizationId,
    teamId,
    healthRecordId,
    travelId,
    travel,
  }: Payload): Promise<ActionResult<ProTravel | TeamTravel>> {
    const body = { travel: toApiTravel(travel) };
    const updatedTravel =
      organizationId && teamId
        ? await this.teamTravelApi.updateTravel(organizationId, teamId, healthRecordId, travelId, body)
        : await this.proTravelApi.updateTravel(healthRecordId, travelId, body);

    this.store.setState((state) =>
      state.healthRecords?.[healthRecordId]
        ? {
            healthRecords: {
              ...state.healthRecords,
              [healthRecordId]: {
                ...state.healthRecords[healthRecordId],
                travels: (state.healthRecords[healthRecordId].travels ?? []).map((current) =>
                  current.id === travelId ? updatedTravel : current,
                ),
              },
            },
          }
        : state,
    );

    return { type: "success", value: updatedTravel };
  }
}
